import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaQuoteLeft, FaStar } from "react-icons/fa6";

const testimonials = [
  {
    name: "Kuldeep Sharma",
    location: "Ghaziabad",
    feedback: "Adv. Saurav Dagar is exceptionally sharp with criminal defense. His approach in court is strategic and highly professional.",
  },
  {
    name: "Raj Singh",
    location: "Uttar Pradesh",
    feedback: "The best lawyer for matrimonial and court marriage matters. He handled our case with extreme confidentiality and speed.",
  },
  {
    name: "Rajeev Kumar Ranjan",
    location: "Delhi NCR",
    feedback: "Highly recommended for civil disputes. His deep knowledge of property law saved us from a very complex legal battle.",
  },
];

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const brandGold = "#C8A27C"; // Consistent Classical Gold
  const deepNavy = "#080C10";

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-[#080C10] py-24 px-6 md:px-12 relative overflow-hidden font-serif">
      
      {/* Editorial Watermark */}
      <div className="absolute top-10 left-10 opacity-[0.03] select-none pointer-events-none hidden lg:block">
        <h1 className="text-[12vw] font-black leading-none text-white tracking-tighter">VOX POPULI</h1>
      </div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center relative z-10">
        
        {/* LEFT SIDE: Heading & Stats (5 Columns) */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-[1px]" style={{ backgroundColor: brandGold }}></div>
            <span style={{ color: brandGold }} className="uppercase tracking-[0.4em] text-[10px] font-bold">
              Client Testimonials
            </span>
          </div>
          
          <h2 className="text-5xl md:text-7xl font-bold leading-[1.1] text-white mb-8">
            Trusted <br />
            <span className="italic font-normal opacity-60" style={{ color: brandGold }}>Voices</span>
          </h2>
          
          <p className="text-gray-400 font-sans text-lg leading-relaxed max-w-sm mb-12">
            Advocate Saurav Dagar has built a legacy of justice across Ghaziabad 
            by putting people first. Here is what our clients say.
          </p>

          <div className="flex gap-1 mb-16">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} style={{ color: brandGold }} className="text-sm" />
            ))}
            <span className="text-white/40 text-xs font-sans ml-3 uppercase tracking-widest">5.0 Rating</span>
          </div>

          {/* Vertical Index Navigation */}
          <div className="hidden lg:flex flex-col gap-6">
            {testimonials.map((t, i) => (
              <button 
                key={i}
                onClick={() => setCurrentIndex(i)}
                className="flex items-center gap-4 group text-left"
              >
                <div 
                   className={`h-[2px] transition-all duration-700 ${currentIndex === i ? 'w-16' : 'w-4 opacity-20'}`}
                   style={{ backgroundColor: brandGold }}
                ></div>
                <span className={`text-[10px] uppercase tracking-widest transition-colors duration-500 ${currentIndex === i ? 'text-white' : 'text-white/20'}`}>
                  {t.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE: The Cinematic Testimonial Display (7 Columns) */}
        <div className="lg:col-span-7 relative">
          
          {/* Decorative Corner Accents */}
          <div className="absolute -top-6 -right-6 w-32 h-32 border-t border-r border-white/10 rounded-tr-3xl"></div>
          <div className="absolute -bottom-6 -left-6 w-32 h-32 border-b border-l border-white/10 rounded-bl-3xl"></div>

          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6 }}
              className="bg-white/5 backdrop-blur-xl p-10 md:p-20 rounded-2xl border border-white/10 relative overflow-hidden"
            >
              {/* Floating Quote Icon */}
              <FaQuoteLeft className="absolute top-10 right-10 text-6xl opacity-10" style={{ color: brandGold }} />

              <div className="relative z-10">
                <p className="text-white text-2xl md:text-4xl font-serif italic leading-snug mb-12">
                  "{testimonials[currentIndex].feedback}"
                </p>

                <div className="flex items-center gap-6">
                  <div className="w-16 h-16 rounded-full border border-white/10 flex items-center justify-center bg-white/5">
                    <span className="text-white font-serif text-xl">{testimonials[currentIndex].name[0]}</span>
                  </div>
                  <div>
                    <h4 style={{ color: brandGold }} className="text-xl font-bold uppercase tracking-widest">
                      {testimonials[currentIndex].name}
                    </h4>
                    <p className="text-white/40 text-[10px] uppercase tracking-[0.3em] mt-1">
                      {testimonials[currentIndex].location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Progress Bar */}
          <div className="absolute -bottom-12 left-0 w-full h-[1px] bg-white/10">
             <motion.div 
               key={currentIndex}
               initial={{ width: "0%" }}
               animate={{ width: "100%" }}
               transition={{ duration: 6, ease: "linear" }}
               className="h-full"
               style={{ backgroundColor: brandGold }}
             />
          </div>
        </div>
      </div>

      {/* Jurisdictional Watermark */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 opacity-[0.05] text-[10px] text-white tracking-[1em] uppercase whitespace-nowrap">
        Civil • Criminal • Matrimonial • Accidental • Ghaziabad, U.P.
      </div>
    </section>
  );
};

export default TestimonialSlider;

















